import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    totalAMount: '€{amount}',
    totalReward: 'Total of your earnings',
    validatedReferral: 'Validated referrals',
  },
  fr: {
    totalAMount: '{amount} €',
    totalReward: 'Total de vos gains',
    validatedReferral: 'Parrainages validés',
  },
} as const);

export default locales;
